// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:16:59

export default {
  "id": "ellie-and-friends-venice-carnival",
  "slug": "ellie-and-friends-venice-carnival",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/4e33bc0b312646d0a2fb6d2a86171b8d-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/4e33bc0b312646d0a2fb6d2a86171b8d/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Ellie and Friends Venice Carnival",
      "description": "Step into the glamorous world of Venice Carnival Dressup with Ellie and Friends Venice Carnival, where you can join Ellie and her friends at one of the most extravagant events of the year. The Venice Carnival is all about stunning masks, luxurious costumes, and endless glamour, and now you get to help Ellie and her friends get ready for the big celebration! Design unique looks and create the perfect carnival style with a variety of costumes, accessories, and masks.",
      "instructions": "Left Mouse Button Click",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "cutedressup",
        "fashion",
        "girls",
        "girlsdressup"
      ]
    },
    "zh-CN": {
      "title": "艾莉和朋友们威尼斯狂欢节",
      "description": "踏入充满魅力的威尼斯狂欢节装扮世界，与艾莉和她的朋友们一起参加一年中最盛大的活动。威尼斯狂欢节以令人惊叹的面具、奢华的服装和无尽的华丽为特色，现在你可以帮助艾莉和她的朋友们为这场盛大的庆祝活动做好准备！设计独特的造型，使用各种服装、配饰和面具，打造完美的狂欢节风格。",
      "instructions": "左鼠标键点击",
      "genres": [
        "装扮"
      ],
      "tags": [
        "可爱装扮",
        "时尚",
        "女孩",
        "女孩装扮"
      ]
    },
    "zh-TW": {
      "title": "艾莉與好友們威尼斯化妝舞會",
      "description": "踏入威尼斯化妝舞會的奢華世界，與Ellie和她的朋友們一起參與年度最盛大的盛事。威尼斯化妝舞會關於驚艷的面具、奢華的服裝和無盡的華麗，現在你可以幫助Ellie和她的朋友們為這場盛大慶典做好準備！設計獨特的造型，並使用各種服裝、配飾和面具創造完美的化妝舞會風格。",
      "instructions": "左鍵點擊",
      "genres": [
        "装扮"
      ],
      "tags": [
        "可愛打扮",
        "時尚",
        "女孩",
        "女孩打扮"
      ]
    },
    "zh-HK": {
      "title": "艾莉與好友們威尼斯化妝舞慶典",
      "description": "步進威尼斯化妝舞會的璀璨世界，與 Ellie 及好友們共度一年中最奢華的盛事。威尼斯化妝舞會以驚艷的面具、豪華的服裝和無盡的輝煌為主題，現在你將幫助 Ellie 及她的朋友們為這個盛大的慶典準備！設計獨特造型，利用各種服裝、配件和面具創造完美的化妝舞會風格。",
      "instructions": "左鍵按鈕點擊",
      "genres": [
        "服裝打扮"
      ],
      "tags": [
        "可愛裝扮",
        "時尚",
        "女孩",
        "女孩裝扮"
      ]
    },
    "ja": {
      "title": "エリーと友人たちヴェネツィアカーニバル",
      "description": "エリーやその友達と共に、ヴェネツィア・カーニバルの華やかな世界に足を踏み入れてください。エリーやその友達と共に、年間で最も豪華なイベントの一つに参加できます。ヴェネツィア・カーニバルは魅力的なマスク、豪華なコスチューム、そして終わりなきグラマーで満ちています。今やエリーやその友達が大規模なお祭りに準備をする手伝いができます！様々なコスチューム、アクセサリー、マスクを使ってユニークなスタイルをデザインし、完璧なカーニバルスタイルを作り上げましょう。",
      "instructions": "左マウスボタンクリック",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "可愛なドレスアップ",
        "ファッション",
        "少女",
        "少女ドレスアップ"
      ]
    },
    "ko": {
      "title": "엘리와 친구들의 베네치아 카arnival",
      "description": "Ellie와 친구들의 베니스 카니발 드레스업의 화려한 세계로 들어가세요. 올 한 해 가장 장대한 행사 중 하나에 Ellie와 그녀의 친구들과 함께할 수 있습니다. 베니스 카니발은 장대한 마스크, 화려한 의상, 끝없는 화려함으로 알려져 있으며, 지금은 Ellie와 그녀의 친구들에게 준비하는 큰 축제를 도와보세요! 다양한 의상, 액세서리, 마스크로 독특한 룩을 디자인하고 완벽한 카니발 스타일을 만들어보세요.",
      "instructions": "좌 클릭 버튼 클릭",
      "genres": [
        "의상장식"
      ],
      "tags": [
        "쿵따스",
        "패션",
        "소녀",
        "소녀뷰티메이크업"
      ]
    },
    "fr": {
      "title": "Ellie et ses Amis - Carnaval de Venise",
      "description": "Plongez dans le monde glamourieux du Carnaval de Venise avec Ellie et ses amis à Venise Carnaval, où vous pouvez rejoindre Ellie et ses amis à l'un des événements les plus fastueux de l'année. Le Carnaval de Venise est tout sur des masques époustouflants, des costumes luxueux et un glamour infini, et maintenant, vous pouvez aider Ellie et ses amis à se préparer pour la grande célébration ! Conception de looks uniques et création du style de carnaval parfait avec une variété de costumes, accessoires et masques.",
      "instructions": "Clic gauche de la souris",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "cutedressup",
        "mode",
        "filles",
        "déguisementfilles"
      ]
    }
  }
};
